RivalIQ.apps.Favorites.module('utils', function (utils, App, Backbone, Marionette, $, _) {

    'use strict';

    function deleteHandler(model) {
        return function () {
            const me = this;
            me.$el.button('loading');

            model.destroy()
                .fail(function () {
                    RivalIQ.execute('alert:warning', 'An error occurred deleting this dashboard, please try again.');
                    me.$el.button('reset');
                })
                .done(function () {
                    RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.DashboardDelete, {
                        id: model.id
                    });

                    let path;
                    if (RivalIQ.state.dashboards.length) {
                        path = `/dashboards/${RivalIQ.state.dashboards.first().id}`;
                    } else {
                        path = '/companies';
                    }

                    RivalIQ.execute('history:navigate', path, {
                        trigger: true
                    });
                });
        };
    }

    utils.getDefaultRedirect = function () {
        const dashboard = RivalIQ.state.dashboards.first();
        if (dashboard) {
            return `/dashboards/${dashboard.id}`;
        } else {
            return '/companies';
        }
    };

    utils.showDashboardDeleteModal = function (propable) {
        const dashboardModel = propable.dashboardModel;
        const configurationId = dashboardModel.getProp('configurationId');

        RivalIQ.execute('show:modal', {
            contentText: `Are you sure you want to delete ${dashboardModel.getName()}?`,
            actions: [
                {
                    html: 'Cancel',
                    className: 'btn btn-default',
                    attributes: {
                        type: 'a',
                        'data-dismiss': 'modal'
                    }
                },
                {
                    html: 'Delete',
                    className: 'btn btn-danger',
                    events: {
                        click: deleteHandler(RivalIQ.state.dashboards.get(configurationId))
                    },
                    attributes: {
                        type: 'a',
                        'data-dismiss': 'modal'
                    }
                }
            ]
        });
    };

});
